<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/84DH0J/tc-custom/9781459252165.jpg?1740868338269" alt="This image is the cover for the book Boss's Baby, Expecting!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boss's Baby, Expecting!
      </h1>
      <p class="bookDescription body article font2">
        <b>From secretaryto mistress!</b><br/><br/>When her fiancé ditched her, Olivia's world was blown awayand with it, her natural caution. She went to the office partyand ended up making love with her handsome boss!<br/><br/>Not that Lewis protested. Soon he and Olivia had more than a working relationshiptop of their agenda was an affair!<br/><br/>But Olivia had a secret: their first reckless encounter had led to something unexpectedshe was having his baby!<br/><br/><b>She's sexy, she's successfuland she's PREGNANT!</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miranda Lee
      </h2>
      
      <p class="authorDescription body article">After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a9cf3fe4